// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"afd87317","426":"fa40297b","651":"e01ff7e3","678":"9449ce72","720":"6d9207af","748":"fa8fc6c1","779":"cf25fcd0"}[chunkId] + ".chunk.js";
};